
import ContactForm from "../ContactForm/ContactForm";
import './Modal.scss'

export default function Modal({open, setOpen}){

   
    if (open){
    return(
        <div className="Modal">
            
            <div className="modal-container">
                <div className="close" onClick={setOpen}>X</div>
                <ContactForm />
            </div>
            
        </div>
    )
    }
}